export default function getUserAgent(): string {
  return navigator.userAgent || navigator.vendor || window["opera"];
}
